import { createContext } from 'react';

export const ParentContext = createContext<any>(null);